// Форматирует дату в формат DD.MM.YYYY
export const formatDate = (inputDate: string): string => {
  const date = new Date(inputDate);

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}.${month}.${year}`;
};

// Конвертирует UTC дату в локальную (+3 часа)
export const convertUtcToLocal = (utcDate: string): Date => {
  const date = new Date(utcDate);
  date.setHours(date.getHours() + 3);
  return date;
};

// Форматирует дату и время в формат DD.MM.YYYY HH:MM
export const formatDateTime = (utcDate: string): string => {
  const localDate = convertUtcToLocal(utcDate);
  const day = localDate.getDate().toString().padStart(2, '0');
  const month = (localDate.getMonth() + 1).toString().padStart(2, '0');
  const year = localDate.getFullYear();
  const hours = localDate.getHours().toString().padStart(2, '0');
  const minutes = localDate.getMinutes().toString().padStart(2, '0');

  return `${day}.${month}.${year} ${hours}:${minutes}`;
};
